const tealeafUnmaskFlag = '_tealeaf-unmask';

/** Appends a special flag to the end of the string.
 *
 * Acoustic tealeaf will run a regex on the `id` and if it detects the presence of the flag, it will NOT obscure the text in the session capture recording
 **/
export const unmaskId = <Id extends string>(id: Id) => {
  return `${id}${tealeafUnmaskFlag}` as const;
};
